import React from 'react'

export default props => <p>Saving...</p>


// WEBPACK FOOTER //
// ./src/pages/RepositoryEdit/SaveBranchDialog/BranchSave/Saving.js